

import React, { useEffect, useState, useRef } from "react";
import { useCalendar } from './CalenderContext';

import DayView from "./Dayview";
import WeekView from "./Weekview";
import MonthView from "./Monthview";
import Dashboardnavbarcopy from '../../layout/Dashboardnavbarcopy';
import { DropdownArrow } from "../AllSvg";
import { CreateRoomModal, ViewRoomModal } from './CreateRoommodel';
import { ViewMeetingModal } from "./CreateMeetingModal";
const AccordionItem = ({ title, children, isOpen, onToggle }) => {
  return (
    <div className="accordion-item">
      <div className="accordion-header flex items-center justify-between" onClick={onToggle}>
        <h4>{title}</h4>
        <svg
          stroke="currentColor"
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 24 24"
          className={`text-xs text-gray-500 transform transition-transform ${isOpen ? "rotate-180" : ""}`}
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M16.293 9.293 12 13.586 7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707z"></path>
        </svg>
      </div>
      {isOpen && <div className="accordion-content">{children}</div>}
    </div>
  );
};

// CheckboxItem Component
const CheckboxItem = ({ id, label, color, checked, onChange }) => {
  return (
    <div className="flex items-center gap-x-1 mb-1">
      <input
        type="checkbox"
        id={id}
        name={id}
        checked={checked}
        onChange={() => onChange(id)}
      />
      <label
        className="text-sm font-normal px-2 rounded py-px text-gray-900 hover:bg-gray-100 capitalize"
        htmlFor={id}
        style={{ color }}
      >
        {label}
      </label>
    </div>
  );
};
function Calender() {
  const {
    currentMonthIdx,
    currentYear,
    currentMonth,
    events,
    view,
    selectedDate,
    // createButtonModal,
    setcreateButtonModal,
    handlePrevMonth,
    handleNextMonth,
    handlePrevDay,
    handleNextDay,
    handleToday,
    handleDayClicksidebar,
    handleViewChange,
    handleCreateRoomButtonClick,
    handleCloseRoomModal,
    handleRoomCreated,
    createroomButtonModal,
    getRoomdata,
    showRoomModal,
    handlecloseRoomModal,
    handleopenRoomModal,
    roomData,
    handlePrevWeek,
    handleNextWeek,
    getWeekDateRange,
    isSidebarOpen,
    toggleSidebar,
    toggleMeetingDropdown,
    showMeetingDropdown,
    getRelevantMeetings,
    formatTime,
    isAccordionOpen,
    handleToggleAccordion,
    showFilterMenu, toggleFilterMenu,
    // filters,
    // handleFilterChange,
    Applyfilters,
    ResetFilters,
    Upcomingmeetinglist,
    formatTime2,
    showViewmeetingModalAll,
    getRandomColor,
    showViewmeetingModal,
    setViewMeetingModal,
    handleShow,
    handleclose,
    eventId,
    position,
    timeSlots,
    setPosition,
    showModal,
    setShowModal,
    meetingData,
    filterItems,
    handleShowAllEventDetail,
    // handleDayclick,
  } = useCalendar();
  const [formData, setFormData] = useState({
    date: "",
    room: '',

  });

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const handleInputChange = (e) => {
    const { name, value, type, checked, options, files } = e.target;

    let newValue;
    if (type === "select-multiple") {
      newValue = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
    } else if (type === "checkbox") {
      newValue = checked;
    } else if (type === "file") {
      newValue = files.length > 0 ? files[0] : null;
    } else {
      newValue = value;
    }


    if (name === "date" && value) {
      const selectedDate = new Date(value);
      const currentDate = new Date();





    }

    setInputState((prevState) => ({
      ...prevState,
      [name]:
        type === "checkbox"
          ? checked
            ? "green"
            : ""
          : newValue
            ? "green"
            : "",
    }));


    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        [name]: newValue,
      };

      return updatedFormData;
    });
    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };
  const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const today = new Date();
  const todayDate = today.getDate();
  const todayMonth = today.getMonth();
  const todayYear = today.getFullYear();
  const [createButtonModal, setCreateButtonModal] = useState(false);


  const [filters, setFilters] = useState({
    accepted: true,
    pending: true,
    rejected: true,
    proposedTime: true,
    denied: true,
    finished: true,
  });





  const handleFilterChange = (id) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [id]: !prevFilters[id],
    }));
  };
  const eventClickRef = useRef(false);
  const handleEventClick = (e, events, day) => {
    // console.log("clicked")
    // Set the flag to indicate this click originated from an event
    eventClickRef.current = true;

    // Call stopPropagation as a first line of defense
    e.stopPropagation();
    e.preventDefault();

    // Process the event click
    handleShowAllEventDetail(e, events, day);
  };

  return (
    <React.Fragment>
      <Dashboardnavbarcopy name="Meeting Scheduler" url="Meeting Scheduler" />
      <div className="content-tabs" style={{ borderRadius: '16px' }}>
        <header className="calendar-header">
          {/* Left Section: Calendar Title and Today Button */}
          <div className="header-left">
            <h1 className="calendar-title">Calendar</h1>
            <button onClick={handleToday} className="model-button-cancel model-button">Today</button>
            <div>
              <div title="view" className="flex-column form-group-select" >
                <select
                  id="View"
                  name="View"
                  onChange={handleViewChange} value={view}
                  className="attendance-input-field width-10vw"
                  style={{ width: '7vw', marginTop: "20px", marginLeft: '20px', cursor: 'pointer' }}
                >
                  <option value="day">Day</option>
                  <option value="month">Month</option>
                  <option value="week">Week</option>
                </select>
                <div>
                </div>
              </div>
            </div>
          </div>


          {/* Center Section: Date Navigation */}
          <div className="header-center">
            {view === "day" ? (
              <>
                <button onClick={handlePrevDay} className="calendar-button prev-button small-button">
                  <span className="material-icons-outlined">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M15 18l-6-6 6-6"></path>
                    </svg>
                  </span>
                </button>

                <p className="calendar-month">
                  {selectedDate?.toLocaleDateString("en-US", {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  })}
                </p>

                <button onClick={handleNextDay} className="calendar-button next-button small-button">
                  <span className="material-icons-outlined">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M9 18l6-6-6-6"></path>
                    </svg>
                  </span>
                </button>
              </>
            ) : view === "week" ? (
              <>
                <button onClick={handlePrevWeek} className="calendar-button prev-button small-button">
                  <span className="material-icons-outlined">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M15 18l-6-6 6-6"></path>
                    </svg>
                  </span>
                </button>

                <p className="calendar-month">
                  {getWeekDateRange()}
                </p>

                <button onClick={handleNextWeek} className="calendar-button next-button small-button">
                  <span className="material-icons-outlined">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M9 18l6-6-6-6"></path>
                    </svg>
                  </span>
                </button>
              </>
            ) : (
              <>
                <button onClick={handlePrevMonth} className="calendar-button prev-button small-button">
                  <span className="material-icons-outlined">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M15 18l-6-6 6-6"></path>
                    </svg>
                  </span>
                </button>

                <button onClick={handleNextMonth} className="calendar-button next-button small-button">
                  <span className="material-icons-outlined">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M9 18l6-6-6-6"></path>
                    </svg>
                  </span>
                </button>

                <p className="calendar-month monthmainheader">
                  {new Date(currentYear, currentMonthIdx).toLocaleString("default", {
                    month: "long",
                  })}{" "}
                  {currentYear}
                </p>
              </>
            )}
          </div>

          <div className="header-right" style={{ position: 'relative' }}>
            <CreateRoomModal
              isOpen={createroomButtonModal}
              onClose={() => handleCloseRoomModal()}
              handleShow={handleCreateRoomButtonClick}
              onRoomCreated={handleRoomCreated}
              getRoomdata={getRoomdata}
            />
            <ViewRoomModal
              isOpen={showRoomModal}
              onClose={() => handlecloseRoomModal()}
              handleShow={handleopenRoomModal}
              roomData={roomData}
              getRoomdata={getRoomdata}

            />
            <button onClick={toggleMeetingDropdown} className="hamburger-button" title="Meeting List" style={{ position: 'relative', backgroundColor: "#2576bc", color: "white", height: '29px' }}>
              <span className="hamburger-icon">
                <span className="hamburger-line" style={{ backgroundColor: "white" }}></span>
                <span className="hamburger-line" style={{ backgroundColor: "white" }}></span>
                <span className="hamburger-line" style={{ backgroundColor: "white" }}></span>

              </span>
            </button>



            <div className={`notifaction-wrapper ${showMeetingDropdown ? 'active' : ''}`} style={{ display: showMeetingDropdown ? "block" : 'none' }}>
              <div class="cross-noti-box flex space-between align-center">
                <h3 className="meetings-dropdown-title">
                  {view === 'day'
                    ? `Meetings for ${selectedDate?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`
                    : view === 'week'
                      ? 'Meetings this week'
                      : 'Meetings this month'}
                </h3>
              </div>
              <div class="inner-notifaction">
                <div class="notificationallbox">
                  {Upcomingmeetinglist.length > 0 ? (
                    Upcomingmeetinglist.map((meeting) => (
                      <div key={meeting.id} className="notifaction-box" >

                        <div className="text-box" style={{ cursor: "pointer" }} onClick={(e) => handleEventClick(e, events)}>
                          <ul>
                            <li>
                              <h6>{meeting.title} <span>{formatTime2(meeting.start_time)}</span><span> {new Date(meeting.meeting_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</span></h6>

                            </li>
                            <li>
                              <p className="normalpnotifications">
                                {meeting?.venue ? meeting?.venue : meeting?.outside_venue}
                              </p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="no-meetings">No meetings scheduled</p>
                  )}
                </div>
              </div>
            </div>

          </div>
        </header>

        <div className="main-content">

          <aside className="sidebar-container">

            <div className="sidebar-top-actions">

              <AccordionItem title="My Calendar" isOpen={isAccordionOpen} onToggle={handleToggleAccordion}>
                {filterItems.map((item) => (
                  <CheckboxItem
                    key={item.id}
                    id={item.id}
                    label={item.label}
                    color={item.color}
                    checked={filters[item.id]}
                    onChange={handleFilterChange}
                  />
                ))}
              </AccordionItem>

              <div className="filter-menu-container">
                <button onClick={toggleFilterMenu} className="hamburger-button" title="Filter Options">
                  <span className="hamburger-icon">
                    <span className="hamburger-line"></span>
                    <span className="hamburger-line"></span>
                    <span className="hamburger-line"></span>
                  </span>
                </button>

                {showFilterMenu && (
                  <div className="filter-dropdown">
                    <h3 className="filter-title">Filter Options</h3>
                    <div className="filter-options">
                      <div title="date" className="flex-column">
                        <label htmlFor="date" className="form-labels">
                          Meeting Date <span className="required">*</span>
                        </label>
                        <input
                          type="date"
                          id="date"
                          name="date"
                          onChange={handleInputChange}
                          value={formData.date}
                          className={`form-inputt ${errors.date ? "error" : inputState.date ? "success" : ""}`}
                        />
                        {errors.date && <span className="error-message">{errors.date}</span>}
                      </div>
                      <div className="flex-column form-group-selectt">
                        <label className="form-labels">
                          Room<span className="required">*</span>
                        </label>
                        <br />
                        {roomData.length === 0 ? (
                          <div className="form-loader" style={{ width: '10vw' }}>
                            <div className="bar-loader" style={{ width: '10vw' }}></div>
                          </div>
                        ) : (
                          <>
                            <select
                              name="venue"
                              onChange={handleInputChange}
                              value={formData.venue}
                              className={`form-input form-group-selection-input ${errors.venue ? "error" : inputState.venue ? "success" : ""
                                }`}
                            >
                              <option value="">Select venue</option>
                              {roomData?.map((room) => (
                                <option value={room.id}>{room.name}</option>
                              ))}
                            </select>
                            <div>
                              {errors.venue && <span className="error-message">{errors.venue}</span>}
                            </div>
                          </>
                        )}
                      </div>

                      <div className="filter-buttons">
                        <button
                          className="filter-button filter-apply"
                          onClick={() => Applyfilters(formData.date, formData.venue)}
                        >
                          Apply Filters
                        </button>
                        <button
                          className="filter-button filter-reset"
                          onClick={() => {
                            setFormData({
                              date: "",
                              room: "",
                            });
                            ResetFilters();
                          }}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>

            </div>

            {/* Calendar Navigation */}
            <div className="calendar-navigation">
              {view === "day" ? (
                <>
                  <button onClick={handlePrevDay} className="calendar-button prev-button small-button">
                    <span className="material-icons-outlined">{"<"}</span>
                  </button>
                  <p className="calendar-month">
                    {selectedDate?.toLocaleDateString("en-US", {
                      month: "long",
                      day: "numeric",
                      year: "numeric",
                    })}
                  </p>
                  <button onClick={handleNextDay} className="calendar-button next-button small-button">
                    <span className="material-icons-outlined">{">"}</span>
                  </button>
                </>
              ) : (
                <>
                  <button onClick={handlePrevMonth} className="calendar-button prev-button small-button">
                    <span className="material-icons-outlined">{"<"}</span>
                  </button>
                  <p className="calendar-month">
                    {new Date(currentYear, currentMonthIdx).toLocaleString("default", {
                      month: "long",
                    })}{" "}
                    {currentYear}
                  </p>
                  <button onClick={handleNextMonth} className="calendar-button next-button small-button">
                    <span className="material-icons-outlined">{">"}</span>
                  </button>
                </>
              )}
            </div>

            {/* Month Selector */}
            <div className="month-selector">
              {daysOfWeek.map((dayName, idx) => (
                <span key={idx} className="week-day">
                  {dayName.charAt(0)}
                </span>
              ))}

              {currentMonth.map((row, i) => (
                <React.Fragment key={i}>
                  {row.map((day, idx) => {
                    const isToday =
                      day &&
                      day.getDate() === todayDate &&
                      day.getMonth() === todayMonth &&
                      day.getFullYear() === todayYear;

                    const isSelected =
                      day &&
                      selectedDate &&
                      day.getDate() === selectedDate.getDate() &&
                      day.getMonth() === selectedDate.getMonth() &&
                      day.getFullYear() === selectedDate.getFullYear();

                    return (
                      <button
                        key={idx}
                        className="day-button-small"
                        onClick={() => handleDayClicksidebar(day)}
                      >
                        <span className='day-number' ><span className={` ${isSelected ? "selected" : ""} ${isToday ? "today" : ""} `}>{day ? day.getDate() : ""}</span></span>
                      </button>
                    );
                  })}
                </React.Fragment>
              ))}
            </div>

            {/* Accordion for Filters */}

          </aside>

          {view === "day" && <DayView selectedDate={selectedDate} />}
          {view === "week" && <WeekView selectedDate={selectedDate} />}
          {view === "month" && <MonthView selectedDate={selectedDate} />}
        </div>
      </div>
    </React.Fragment>
  );
}

export default Calender;

